var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.header.value == 'Flags')?[((!_vm.isEditing) || _vm.hasReplicates)?[_vm._v("\n      "+_vm._s(_vm.flagsDisplayText)+"\n    ")]:[_c('v-btn',{staticClass:"dropdown-btn ma-0",attrs:{"block":"","flat":""}},[_c('v-icon',[_vm._v("arrow_drop_down")])],1)]]:[_vm._v("\n    "+_vm._s(_vm.valueToDisplay)+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }